/**
 * ResponseRoboCnpj
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseRoboCnpjCollection} from '@/model/collection/ResponseRoboCnpjCollection'

/* TODO: review generated class */
export class ResponseRoboCnpj extends Resource {
  idResponsePk: number = 0

  cnpj: string | null = null
  response: string | null = null

  get $id() {
    return this.idResponsePk
  }
  set $id(val) {
    this.idResponsePk = val
  }

  /**
   * Gets a instance of a given ID of ResponseRoboCnpj
   */
  async getResponseRoboCnpj(id: number) {
    return await Request.get(`/admin/response-robo-cnpj/${id}`)
      .name('getResponseRoboCnpj')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ResponseRoboCnpj
   */
  static async listResponseRoboCnpj(params: any) {
    return await Request.get(`/admin/response-robo-cnpj`, {params})
      .name('listResponseRoboCnpj')
      .as(ResponseRoboCnpjCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponseRoboCnpj. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponseRoboCnpj() {
    return await Request.post(`/admin/response-robo-cnpj`, this)
      .name('persistResponseRoboCnpj')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponseRoboCnpj to use it in a CSV file
   */
  static async listCsvResponseRoboCnpj(params: any) {
    return await Request.get(`/admin/response-robo-cnpj/csv`, {params})
      .name('listCsvResponseRoboCnpj')
      .as(ResponseRoboCnpjCollection)
      .getData()
  }
}
